import { render, staticRenderFns } from "./input-readonly.vue?vue&type=template&id=c12eafae&"
import script from "./input-readonly.vue?vue&type=script&lang=js&"
export * from "./input-readonly.vue?vue&type=script&lang=js&"
import style0 from "./input-readonly.vue?vue&type=style&index=0&id=c12eafae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports